<template>
  <!-- 购物车 -->
  <div class="index-container">
    <div class="index-content">
      <div class="nav-box">
        首页 > 柏瑞康书斋
        <span>> 购物车</span>
      </div>
      <div class="shop-content">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="100" label="全选"></el-table-column>
          <el-table-column prop width="400" label="商品">
            <template slot-scope="scope">
              <div class="shop-box">
                <div
                  class="shop-img"
                  :style="{ backgroundImage: 'url( ' + imgUrl + scope.row['goods_img']+ ')' }"
                ></div>
                <div class="shop-name">{{scope.row.title}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单价">
            <template slot-scope="scope">¥{{scope.row.price}}.00</template>
          </el-table-column>
          <el-table-column label="数量" width="220">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.stock"
                @change="numHandleChange(scope.row)"
                :min="1"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="小计">
            <template slot-scope="scope">¥{{ scope.row.price * scope.row.stock }}.00</template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="button-box">
                <div @click="deleteShop(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="bottom-content">
      <div class="bottom-box">
        <div class="b-flex">
          <el-checkbox @change="handleCheckAllChange()" v-model="checkedAll">全选</el-checkbox>
          <div class="delete-shop" @click="deleteAllShop">删除选中商品</div>
          <div class="clear-shop" @click="clearShop">清空购物车</div>
        </div>
        <div class="b-flex">
          <div class="select-box">
            已选择
            <span>{{totalNum}}</span> 件商品
          </div>
          <div class="price-box">
            总价
            <span>¥{{totalPrice}}.00</span>
          </div>
          <div class="settle-button" @click="goPay">去结算</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../api/api';
import { imgUrl } from '../api/index';

export default {
  name: 'shoppingCart',
  data() {
    return {
      imgUrl: imgUrl,
      tableData: [],
      multipleSelection: []
      //   checkedAll: false,
      //   totalNum: 1
      //   totalPrice: 0
    };
  },
  computed: {
    checkedAll: {
      get() {
        return this.multipleSelection.length === this.tableData.length;
      },
      set() {}
    },
    totalPrice() {
      let total = 0;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        total +=
          this.multipleSelection[i].price * this.multipleSelection[i].stock;
      }
      return total;
    },
    totalNum() {
      return this.multipleSelection.length;
    }
  },
  created() {
    this.getShopList();
  },
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    // 删除商品
    deleteShop(item) {
      api.deleteShop({ id: item.id }).then(res => {
        console.log(res);
        if (res.result) {
          this.getShopList();
          this.$message.success('删除成功！');
        } else {
          this.$message.warning('删除失败！');
        }
      });
    },
    // 批量删除
    deleteAllShop() {
      if (this.multipleSelection.length <= 0) {
        this.$message.warning('请至少选择一条数据!');
        return;
      }
      let arr = [];
      this.multipleSelection.forEach(ele => {
        arr.push(ele.id);
      });
      console.log(arr);
      const params = {
        goods: arr
      };
      api.deleteAllShop(params).then(res => {
        console.log(res);
        if (res.result) {
          this.getShopList();
          this.$message.success('删除成功！');
        } else {
          this.$message.warning('删除失败！');
        }
      });
    },
    // 清空购物车
    clearShop() {
      let arr = [];
      this.tableData.forEach(ele => {
        arr.push(ele.id);
      });
      console.log(arr);
      const params = {
        goods: arr
      };
      api.deleteAllShop(params).then(res => {
        console.log(res);
        if (res.result) {
          this.getShopList();
          this.$message.success('删除成功！');
        } else {
          this.$message.warning('删除失败！');
        }
      });
    },
    // 获取购物车列表
    getShopList() {
      api.getShopList().then(res => {
        console.log(res);
        if (res.result) {
          this.tableData = res.result;
        }
      });
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    numHandleChange(value) {
      console.log(value);
      this.goShopCart(value.good_uuid, value.stock);
    },
    // 加入购物车
    goShopCart(good_uuid, stock) {
      const params = {
        good_uuid: good_uuid,
        stock: stock,
        is_add: 2
      };
      api.addCart(params).then(res => {
        console.log(res);
        if (res.result) {
          this.getShopList();
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    handleCheckAllChange(val) {
      console.log(this.checkedAll);
      if (!this.checkedAll) {
        this.multipleSelection = this.tableData;
        this.tableData.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 去结算
    goPay() {
      if (this.multipleSelection.length <= 0) {
        this.$message.warning('请至少选择一条数据!');
        return;
      }
      let arr = [];
      this.multipleSelection.forEach(ele => {
        arr.push(ele.good_uuid);
      });
      const params = {
        goods: arr,
        create_type: 2
      };
      api.getGoodOrder(params).then(res => {
        console.log(res);
        if (res.result) {
          this.$message.success('提交成功！');
          this.$router.push({
            path: '/shoppingPay',
            query: { order_sn: res.result.order_sn }
          });
        } else {
          this.$message.warning('提交失败！');
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.index-content {
  width: 72%;
  padding: 50PX 0 0;
  margin: 0 auto;
}
.nav-box {
  margin-bottom: 40PX;
  font-size: 16PX;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.shop-box {
  display: flex;
  align-items: center;
  .shop-name {
    flex: 1;
    padding-left: 10PX;
  }
}
.shop-img {
  width: 130PX;
  height: 130PX;
  background-color: cornsilk;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.shop-content {
  margin-bottom: 54PX;
}
.button-box {
  display: flex;
  margin: 0 auto;
  > div {
    width: 86PX;
    margin: 0 auto;
    line-height: 34PX;
    text-align: center;
    border-radius: 20PX;
    border: 1PX solid #a5a5a5;
    cursor: pointer;
  }
  .btn {
    margin-left: 22PX;
    color: #f1a373;
    border-color: #f1a373;
  }
}
.bottom-content {
  background-color: #ffffff;
  .bottom-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 72%;
    margin: 0 auto;
    padding-left: 40PX;
  }
  .b-flex {
    position: relative;
    display: flex;
    align-items: center;
  }
  .delete-shop {
    padding: 0 46PX 0 60PX;
    color: #898989;
    cursor: pointer;
    &:hover {
      color: #f1a373;
    }
  }
  .clear-shop {
    color: #969696;
    cursor: pointer;
    &:hover {
      color: #f1a373;
    }
  }
  .select-box {
    padding-right: 2vw;
    color: #888888;
    // line-height: 88PX;
    span {
      color: #f1a373;
    }
  }
  .price-box {
    position: relative;
    top: -6PX;
    padding-right: 36PX;
    color: #888888;
    // line-height: 74PX;
    span {
      font-size: 30PX;
      color: #c00c0c;
    }
  }
  .settle-button {
    width: 302PX;
    font-size: 26PX;
    color: #ffffff;
    line-height: 88PX;
    text-align: center;
    background: #f1a475;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
/deep/ {
  .el-table th {
    text-align: center;
  }
  .el-table__row td {
    text-align: center;
  }
  .el-input__inner {
    border-radius: 19PX;
  }
  .el-input-number__decrease {
    border-radius: 19PX 0 0 19PX;
    background-color: #ffffff;
  }
  .el-input-number__increase {
    border-radius: 0 19PX 19PX 0;
    background-color: #ffffff;
  }
  .el-table__row td {
    padding: 20PX 0;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #f1a475;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #f1a475;
    border-color: #f1a475;
  }
  .el-checkbox__inner:hover,
  .el-input-number__decrease:hover:not(.is-disabled)
    ~ .el-input
    .el-input__inner:not(.is-disabled),
  .el-input-number__increase:hover:not(.is-disabled)
    ~ .el-input
    .el-input__inner:not(.is-disabled) {
    border-color: #f1a475;
  }
  .el-input-number__decrease:hover,
  .el-input-number__increase:hover {
    color: #f1a475;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/shoppingCart.vue